import React, { useState, useRef, } from "react";
import { FormattedMessage, useIntl, } from "react-intl";
import { Input, Badge, Button, Space, Dropdown, Popover, } from 'antd';
import debounce from 'lodash.debounce';
import { FunnelIcon, CaretDownIcon, } from "@phosphor-icons/react";

const TableHeaderSearch = ({
    searchInput,
    setSearchInput,
    setTableLoading,
    resetData,
    buttons = [],
    filteredInfo = {},
    setFilteredInfo,
    label = 'search',
    ...props
}) => {

    const [inputValue, setInputValue] = useState(searchInput);
    const { Search } = Input;
    const intl = useIntl();

    // first function for interact on the search input
    const handleSearchInput = (event) => {
        const data = {
            'search_value': event.target.value,
            'search_type': '',
        };
        setInputValue(event.target.value);
        handleSearchBarDebounced.current(data);
    };

    // second function, called from the search bar handler
    const handleSearchBarDebounced = useRef(
        debounce(searchInput => {

            // if input field is empty load the total list
            if (searchInput.search_value.length === 0) {
                setTableLoading(false);
                setSearchInput(undefined);
                resetData();
            } else {
                handleSearchBar(searchInput);
            }
        }, 500)
    );

    // search bar handler
    const handleSearchBar = (p_SearchInput) => {
        // setCustomerData([]);
        if (p_SearchInput.search_value.length > 2) {
            setTableLoading(true);
            setSearchInput(p_SearchInput.search_value);
        }
    };

    const countFilter = () => {
        let counter = 0;

        // check how many filters has been set.
        for (let index = 0; index < Object.keys(filteredInfo).length; index++) {
            const element = Object.keys(filteredInfo)[index];
            if (filteredInfo[element]) {
                counter++;
            }
        }
        return counter;
    };

    const clearFilters = () => {
        setFilteredInfo({});
    };

    return (
        <div className="p-4 text-left">
            <Popover
                content="Minimaal 3 karakters om te zoeken."
                open={inputValue && inputValue?.length < 3}>
                <Search
                    style={{ width: "50%" }}
                    size="large"
                    onChange={event => { handleSearchInput(event) }}
                    value={inputValue}
                    allowClear
                    placeholder={intl.formatMessage({ id: label })}
                    enterButton />
            </Popover>

            <Space className="float-end">
                <Badge count={countFilter()} >
                    <Button
                        disabled={Object.keys(filteredInfo).length === 0}
                        onClick={clearFilters}
                        className="float-en"><FunnelIcon size={18} className="mr-1" /> Reset filters</Button>
                </Badge>

                {/* Adding buttons to the action table header */}
                {buttons.length > 0 && (
                    <Dropdown
                        menu={{ items: buttons }}
                        className="ml-2">
                        <Button type="primary">
                            <FormattedMessage id="actions" /> <CaretDownIcon size={16} className="ml-1" /></Button>
                    </Dropdown>
                )}

            </Space>
        </div>
    );
};

export default TableHeaderSearch;